import React, { useState } from "react";

import Header from "../elements/Header/Header";
import {
  addNewBlock,
  duplicateBlockData,
  INITIAL_LINK_BLOCKS,
  removeBlockById,
  submitLinks,
  updateBlockField,
  updateBlockFile,
} from "./linkiKreatorController";
import "./linkiKreatos.css";

export default function UploadForm() {
  const [blocks, setBlocks] = useState(INITIAL_LINK_BLOCKS);
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState([]);

  const handleChange = (index, field, value) => {
    setBlocks((previous) => updateBlockField(previous, index, field, value));
  };

  const handleFileChange = (index, file) => {
    setBlocks((previous) => updateBlockFile(previous, index, file));
  };

  const handleDeleteBlock = (reactId) => {
    setBlocks((previous) => removeBlockById(previous, reactId));
  };

  const handleDuplicateBlock = (reactId) => {
    setBlocks((previous) => duplicateBlockData(previous, reactId));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    await submitLinks({
      blocks,
      setLoading,
      setResults,
      setBlocks,
    });
  };

  return (
    <div className="linki-kreator">
      <Header />
      <div className="linki-kreator__content">
        <h2 className="linki-h2">Upload reklam HTML</h2>
        <form onSubmit={handleSubmit} className="linki-form">
          {blocks.map((block, idx) => (
            <fieldset key={idx} className="linki-fieldset">
              <legend>Reklama {idx + 1}</legend>
              <div className="linki-fieldset__grid">
                <label className="linki-fieldset__label">
                  Kampania:
                  <input
                    className="linki-fieldset__input"
                    type="text"
                    value={block.campaign}
                    onChange={(event) => handleChange(idx, "campaign", event.target.value)}
                    required
                  />
                </label>
                <label className="linki-fieldset__label">
                  Klient:
                  <input
                    className="linki-fieldset__input"
                    type="text"
                    value={block.client}
                    onChange={(event) => handleChange(idx, "client", event.target.value)}
                    required
                  />
                </label>
                <label className="linki-fieldset__label">
                  Format:
                  <input
                    className="linki-fieldset__input"
                    type="text"
                    value={block.format}
                    onChange={(event) => handleChange(idx, "format", event.target.value)}
                    required
                  />
                </label>
                <label className="linki-fieldset__label">
                  Szerokosc (px):
                  <input
                    className="linki-fieldset__input"
                    type="number"
                    min="1"
                    value={block.width}
                    onChange={(event) => handleChange(idx, "width", event.target.value)}
                    required
                  />
                </label>
                <label className="linki-fieldset__label">
                  Wysokosc (px):
                  <input
                    className="linki-fieldset__input"
                    type="number"
                    min="1"
                    value={block.height}
                    onChange={(event) => handleChange(idx, "height", event.target.value)}
                    required
                  />
                </label>
                <label className="linki-fieldset__label">
                  Urzadzenie:
                  <select
                    className="linki-fieldset__select"
                    value={block.device}
                    onChange={(event) => handleChange(idx, "device", event.target.value)}
                  >
                    <option value="mobile">Mobile + Desktop</option>
                    <option value="desktop">Desktop</option>
                    <option value="display_mobile">Display Uniwersalny</option>
                    <option value="display_desktop">Display Desktop</option>
                    <option value="st_desktop">Sticky Desktop</option>
                    <option value="st_mobile">Sticky Mobile</option>
                    <option value="scroll">SCROLL.me</option>
                    <option value="smart_4">SMART.frame_4</option>
                  </select>
                </label>
                <label className="linki-fieldset__label linki-fieldset__label--file">
                  Plik ZIP:
                  <input
                    className="linki-fieldset__input"
                    type="file"
                    accept=".zip"
                    onChange={(event) => handleFileChange(idx, event.target.files[0])}
                    required
                  />
                </label>
              </div>

              <div className="linki-fieldset__actions">
                <button
                  type="button"
                  className="linki-btn linki-btn--duplicate"
                  onClick={() => handleDuplicateBlock(block.reactId)}
                >
                  Duplikuj dane
                </button>
                <button
                  type="button"
                  className="linki-btn linki-btn--delete"
                  onClick={() => handleDeleteBlock(block.reactId)}
                >
                  Usun X
                </button>
              </div>
            </fieldset>
          ))}

          <div className="linki-btn-wrap">
            <button
              type="button"
              className="linki-btn linki-btn--add"
              onClick={() => setBlocks((previous) => addNewBlock(previous))}
            >
              + Dodaj kolejny element
            </button>
            <br />
            <button className="linki-btn linki-btn--submit" type="submit">
              Wyslij
            </button>
          </div>
        </form>

        <hr />

        {loading && <h1 className="linki-loading">Prosze czekac, kreacje sa dodawane...</h1>}

        {results.length > 0 && (
          <div className="linki-results">
            <h3 className="linki-h3">Wygenerowane linki:</h3>
            <ul>
              {results.map(({ url }, i) => (
                <li key={i} className="linki-linki">
                  <a href={url} target="_blank" rel="noreferrer">
                    {url}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}
